<template>
  <v-data-table :headers="templateItemHeaders" :items="templateItems" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-row align="center">
          <v-col class="text-subtitle-2 gray--text text--lighten-1">
            Vias de aplicação
          </v-col>

          <v-spacer />

          <v-col cols="auto">
            <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                  Nova terapêutica
                </v-btn>
              </template>

              <TemplateItemForm
                :templateItem="editedItem"
                :medicines="medicines"
                :close="close"
                :save="save"
                :formTitle="formTitle"
              />
            </v-dialog>
          </v-col>
        </v-row>
      </v-toolbar>
    </template>

    <template v-slot:item="{ item }">
      <TemplateItemTableRow
        :templateItem="item"
        :editItem="editItem"
        :deleteItem="deleteItem"
        :medicines="medicines"
      />
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há dados cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  import TemplateItemTableRow from "./template_item.vue";
  import TemplateItemForm from "@/components/config/template/clinic-therapy/form/index.vue";

  export default {
    name: "TemplateItemsTable",
    props: {
      template: Object,
      medicines: Array,
      refreshList: Function,
    },
    components: {
      TemplateItemTableRow,
      TemplateItemForm,
    },
    data() {
      return {
        dialog: null,
        editedItem: {
          id: "",
          templateType: "",
          buildingInformation: {
            dilation: false,
            refract: false,
            medicine_id: "",
            medicine_application_route_id: "",
            medicine_application_site_id: "",
            interval: "",
            number_of_applications: "",
          },
        },
        defaultItem: {
          id: "",
          templateType: "",
          buildingInformation: {
            dilation: false,
            refract: false,
            medicine_id: "",
            medicine_application_route_id: "",
            medicine_application_site_id: "",
            interval: "",
            number_of_applications: "",
          },
        },
        editedIndex: -1,
        templateItemHeaders: [
          { text: "Medicamento", value: "medicine_id" },
          { text: "Via de aplicação", value: "medicine_application_route_id" },
          { text: "Local de aplicação", value: "medicine_application_site_id" },
          { text: "Nº de aplicações", value: "number_of_applications" },
          { text: "Intervalo", value: "interval" },
          { text: "Dilatação", value: "dilation" },
          { text: "Refração", value: "refract" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
      };
    },
    computed: {
      templateItems() {
        return this.lodash.filter(this.template.items, {
          templateType: "attendance_therapy",
        });
      },
      formTitle() {
        return this.editedIndex === -1 ? "Novo terapêutica" : "Editar terapêutica";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.templateItems.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar essa terapeutica?")) {
          this.apolloMutate({
            mutation: require("@/graphql/template/delete_template_item.gql"),
            variables: {
              templateItemId: item.id,
            },
          }).then(() => {
            this.refreshList();

            this.$store.dispatch("createNotification", {
              message: "Cadastro deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/template/save_template_item.gql"),
          variables: {
            templateId: this.template.id,
            templateItemId: this.lodash.get(this.editedItem, "id", ""),
            templateType: "attendance_therapy",
            buildingInformation: JSON.stringify(this.editedItem.buildingInformation),
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
